var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nickNameBox",
    attrs: {
      "slot": "reference",
      "title": _vm.nickName
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.sessionSelect || _vm.createSelect
    }
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_vm.sessionInfo.status && _vm.sessionSelect ? _c('micphone', {
    attrs: {
      "level": _vm.level
    }
  }) : _vm._e(), _c('div', {
    staticClass: "nickName"
  }, [_vm._v(_vm._s(_vm.nickName))])], 1), _c('div', {
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "iconBox"
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "IDTips",
      "trigger": "click"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOperation,
      expression: "showOperation"
    }],
    staticClass: "el-icon-more",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    },
    slot: "reference"
  }), _c('div', {
    staticClass: "operationBox",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        return _vm.deleteSource();
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "8px"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('intercom.removeParticipant')))])])])], 1)]), _vm.createSelect ? _c('span', {
    staticClass: "selectIndex"
  }, [_vm._v(_vm._s(_vm.index))]) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.deviceVoIPStatus && !_vm.createSelect,
      expression: "!deviceVoIPStatus && !createSelect"
    }],
    staticClass: "deviceOfflineIcon"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };